import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SaleOptionEditor from "../../../components/SaleOptionEditor";
import { useCombinedStore } from "../../../store";
import * as Styles from "../styles/PointOfSale.styles";
import api from "../../../services/api.service";
import * as AlfredoComponents from "../../../components";
import { ModaisDoPdv } from "./ModaisDoPdv";
import { BotaoDeAcao } from "./campos/BotaoDeAcao";
import { BotaoDePedido } from "./campos/BotaoDePedido";
import { BuscaDeBalcao } from "./campos/BuscaDeBalcao";
import { BuscaDeClientePorTelefone } from "./campos/BuscaDeClientePorTelefone";
import { BuscaDeMesa } from "./campos/BuscaDeMesa";
import { MenuLateral } from "./campos/MenuLateral";
import { RotuloDaConta } from "./campos/RotuloDaConta";
import { RotuloDoCliente } from "./campos/RotuloDoCliente";
import { RotuloDoPeriodo } from "./campos/RotuloDoPeriodo";
import { TabelaDePedidosDeBalcao } from "./campos/TabelaDePedidosDeBalcao";
import { TabelaDePedidosDeDelivery } from "./campos/TabelaDePedidosDeDelivery";
import { TabelaDePedidosDeMesa } from "./campos/TabelaDePedidosDeMesa";
import { TabelaDeProdutos } from "./campos/TabelaDeProdutos";
import { TabelaDeTotais } from "./campos/TabelaDeTotais";
import { UUID } from "crypto";
import { infosDoTipo } from "../../../dominio/conta.tipos";
import {
  contaFoiImpressa,
  lerPagamentosDaConta,
  lerProdutosDaConta,
} from "../../../dominio/produtosDaConta";
import {
  baseDoDesconto,
  descontoDaConta,
  taxasDaConta,
  totaisDaMesa,
  totaisDoBalcao,
  totalDaMesaComDesconto,
  totalDosProdutos,
  totalDosProdutosComDesconto,
} from "../../../dominio/totaisDaConta";
import { rotuloDaOrigemDoCliente } from "../../../dominio/cliente";
import { rotuloDoBotao } from "../../../dominio/rotuloDoBotao";
import { mensagemDeSaudacao } from "../../../dominio/dataEHora";

const PointOfSale: React.FC = () => {

  //#region Importar os parametros de estado do Zustand, Navegacao e Mensagem
  //Parametro de state do Zustand
  const {
    setSubsidiaryDataZustand,
    subsidiaryDataZustand,
    setOrderDataZustand,
    orderDataZustand,
    authUserZustand,
    setMessageZustand,
    saleOptionEditorOpenZustand,
  } = useCombinedStore((state) => {
    return {
      setSubsidiaryDataZustand: state.setSubsidiaryDataZustand,
      subsidiaryDataZustand: state.subsidiaryDataZustand,
      setOrderDataZustand: state.setOrderDataZustand,
      orderDataZustand: state.orderDataZustand,
      setMessageZustand: state.setMessageZustand,
      authUserZustand: state.authUserZustand,
      saleOptionEditorOpenZustand: state.saleOptionEditorOpenZustand,
    };
  });
  const navigate = useNavigate();

  const handleSetMessage = (message: string, messageType: string) => {
    if (currentModalOpen === "") {
      setMessageZustand(message, messageType);
    }
  }
  //#endregion

  //#region Criacao de parametros de estado dos componentes
  //Parametro de state dos componentes
  const [currentModalOpen, setCurrentModalOpen] = useState("");
  const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
  const [confirmationModalOpen, setConfirmModalOpen] = useState({
    title: "",
    description: "",
    confirmationAction: () => { },
    cancelationAction: () => { },
  });
  const [ordersTypeTable, setOrdersTypeTable] = useState("");
  const [lastOrderSelected, setLastOrderSelected] = useState<any | null>(null);
  interface Desk {
    itemUuid: string;
    itemName: string;
    itemOrder: any;
  }
  const [availableDesks, setAvailableDesks] = useState<Desk[]>([]);
  interface Counter {
    itemUuid: string;
    itemName: string;
    itemOrder: any;
  }
  const [availableCounters, setAvailableCounters] = useState<Counter[]>([]);
  const [peopleWithProducts, setPeopleWithProducts] = useState<
    { key: string; label: string; value: string }[]
  >(
    Array.from(
      new Set(
        orderDataZustand?.products
          ?.filter((product) => product.people)
          ?.map((product) => product.people)
      )
    )
      .sort((a, b) => parseInt(a as string) - parseInt(b as string))
      .map((person, index) => ({
        key: `${index + 1}`,
        label: `Lugar ${person}`,
        value: `${person}`,
      })) || []
  );
  //#endregion

  //#region Identificar o cliente e a conta caso exista e os ultimos pedidos caso delivery.
  //Parametro de identificacao do cliente em tela
  const [customerInfoByOrder, setCustomerInfoByOrder] = useState({
    customerName: "",
    customerAddress: "",
    customerAddressComplement: "",
    customerAddressObservation: "",
    customerOrigin: "",
    customerPhone: "",
  });
  const [customerAddressToUpdate, setCustomerAddressToUpdate] = useState({
    customerUuid: "",
    customerOrigin: "",
    //customerPlaceId: "",
    //customerFormattedAddress: "",
    customerAddress: "",
    customerName: "",
    customerPhone: "",
    customerAddressComplement: "",
    customerAddressObservation: "",
  });
  const [searchValueInput, setSearchValueInput] = useState("");
  const searchInputRefType1 = useRef<HTMLInputElement>(null);
  const searchInputRefType2 = useRef<HTMLInputElement>(null);
  const searchInputRefType3 = useRef<HTMLInputElement>(null);

  const resetOrderData = () => {
    setSearchValueInput("");
    if (searchInputRefType1.current) {
      searchInputRefType1.current.value = "";
    } else if (searchInputRefType2.current) {
      searchInputRefType2.current.value = "";
    }
    else if (searchInputRefType3.current) {
      searchInputRefType3.current.value = "";
    }
    setOrderDataZustand({
      orderUuid: "",
      orderCode: "",
      orderOwnerUuid: "",
      orderOwnerName: "",
      orderStatus: 0,
      orderType: "",
      createdAt: "",
      orderInfo: {},
    });
    setLastOrderSelected("");
    setCustomerInfoByOrder({
      customerOrigin: "",
      customerName: "",
      customerAddress: "",
      customerAddressComplement: "",
      customerAddressObservation: "",
      customerPhone: "",
    });
    setCurrentModalOpen("");
    getPeriodInfo();

  };
  //burcar informacoes da conta selecionada
  const handleSearch = async (openNewOrder?: boolean, productExpanded?: boolean) => {
    if (searchValueInput === "") {
      if (orderDataZustand.orderUuid !== "") {
        resetOrderData();
      }
      // if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
      //   setCurrentModalOpen("CustomerModal");
      // }
    } else {
      try {
      switch (selectedSaleOption.itemInfoValue.saleOptionType) {
        case "1":
          const searchDeskComponent =
            selectedSaleOption.itemInfoValue.saleOptionComponents.find(
              (component) => component.componentType === "SearchDesk"
            );
          if (searchDeskComponent) {
            const selectedDesk =
              subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDesks?.filter(
                (desk: any) =>
                  desk.itemName.replace("Mesa ", "") ===
                  searchValueInput.replace("Mesa ", "")
              )[0];
            if (selectedDesk) {
              setSearchValueInput(selectedDesk.itemName);
              if (searchInputRefType1.current) {
                searchInputRefType1.current.value = selectedDesk.itemName;
              }
              const currentOrderResponse = await api.get(
                `orderByItem/${selectedDesk.itemUuid}`
              );

              if (
                currentOrderResponse.data.currentOrderByItem === undefined &&
                openNewOrder !== false
              ) {
                setCurrentModalOpen("OrderDeskModal");
              } else if (currentOrderResponse.data.currentOrderByItem !== undefined) {
                const infosDaConta =
                  currentOrderResponse.data.currentOrderByItem.order.orderInfo;
                const peopleNumber = infosDoTipo(infosDaConta, 2);
                const products = infosDoTipo(infosDaConta, 3);
                const peopleNumberParsed = JSON.parse(peopleNumber[0].orderInfoValue);
                const totalForAllPeopleWithDiscount = totalDaMesaComDesconto(
                  products,
                  peopleNumberParsed
                );
                // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos
                // seis caminhos e a mesma do cupom impresso. Card 25.
                // `totalDaMesaComDesconto` continua sendo o subtotal EXIBIDO.
                const orderDiscount = descontoDaConta(
                  infosDaConta,
                  baseDoDesconto(products)
                );
                const orderTaxs = taxasDaConta(infosDaConta);
                const totals = totaisDaMesa({
                  products,
                  orderTaxs,
                  lugares: peopleNumberParsed,
                  totalComDesconto: totalForAllPeopleWithDiscount,
                  desconto: orderDiscount,
                });
                const orderPrinted: boolean = contaFoiImpressa(infosDaConta);

                setOrderDataZustand({
                  orderUuid: currentOrderResponse.data.currentOrderByItem.order.orderUuid,
                  orderCode: currentOrderResponse.data.currentOrderByItem.order.orderCode,
                  orderOwnerUuid:
                    currentOrderResponse.data.currentOrderByItem.order.updatedBy,
                  orderOwnerName:
                    currentOrderResponse.data.currentOrderByItem.order.updatedByUuid
                      .userSocialName,
                  orderStatus:
                    currentOrderResponse.data.currentOrderByItem.order.orderStatus,
                  orderType: String(currentOrderResponse.data.currentOrderByItem.order.orderType),
                  createdAt: currentOrderResponse.data.currentOrderByItem.order.createdAt,
                  orderInfo: {
                    orderPrinted: orderPrinted,
                    peopleNumber: peopleNumber[0].orderInfoValue,
                    deskUuid: selectedDesk.itemUuid,
                    orderTaxs: [...orderTaxs],
                    orderPayments: lerPagamentosDaConta(infosDaConta),
                  },
                  products: lerProdutosDaConta(products, {
                    seller: authUserZustand?.userInfo.userSocialName,
                    comExpandido: true,
                    productExpanded,
                    comLugar: true,
                  }),
                  totals: totals,
                });
              }
            }



            else {
              handleSetMessage(
                `Mesa ${searchValueInput.replace("Mesa ", "")} não encontrada.`,
                `error`
              );
              resetOrderData();
            }
          }
          break;
        case "2":
          const searchCounterComponent =
            selectedSaleOption.itemInfoValue.saleOptionComponents.find(
              (component) => component.componentType === "SearchCounter"
            );
          if (searchCounterComponent) {
            const selectedCounter =
              subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodCounters?.filter(
                (counter: any) =>
                  counter.itemName.replace("Balcão ", "") ===
                  searchValueInput.replace("Balcão ", "")
              )[0];
            if (selectedCounter) {
              setSearchValueInput(selectedCounter.itemName);
              if (searchInputRefType2.current) {
                searchInputRefType2.current.value = selectedCounter.itemName;
              }
              const currentOrderResponse = await api.get(
                `orderByItem/${selectedCounter.itemUuid}`
              );
              if (currentOrderResponse.data.currentOrderByItem === undefined && openNewOrder !== false) {
                setCurrentModalOpen("OrderCounterModal");
              } else if (currentOrderResponse.data.currentOrderByItem !== undefined) {
                const infosDaConta =
                  currentOrderResponse.data.currentOrderByItem.order.orderInfo;
                const products = infosDoTipo(infosDaConta, 3);
                const productTotals = totalDosProdutos(products);
                const orderTaxs = taxasDaConta(infosDaConta);
                const productTotalsWithDiscount = totalDosProdutosComDesconto(products);
                // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos
                // seis caminhos e a mesma do cupom impresso. Card 25.
                const orderDiscount = descontoDaConta(
                  infosDaConta,
                  baseDoDesconto(products)
                );
                const totals = totaisDoBalcao({
                  orderTaxs,
                  totalDeProdutos: productTotals,
                  totalComDesconto: productTotalsWithDiscount,
                  desconto: orderDiscount,
                });
                const orderPrinted: boolean = contaFoiImpressa(infosDaConta);

                setOrderDataZustand({
                  orderUuid: currentOrderResponse.data.currentOrderByItem.order.orderUuid,
                  orderCode: currentOrderResponse.data.currentOrderByItem.order.orderCode,
                  orderOwnerUuid:
                    currentOrderResponse.data.currentOrderByItem.order.updatedBy,
                  orderOwnerName:
                    currentOrderResponse.data.currentOrderByItem.order.updatedByUuid
                      .userSocialName,
                  orderStatus:
                    currentOrderResponse.data.currentOrderByItem.order.orderStatus,
                  orderType: String(currentOrderResponse.data.currentOrderByItem.order.orderType),
                  createdAt: currentOrderResponse.data.currentOrderByItem.order.createdAt,
                  orderInfo: {
                    orderPrinted: orderPrinted,
                    counterUuid: selectedCounter.itemUuid,
                    orderTaxs: [...orderTaxs],
                    orderPayments: lerPagamentosDaConta(infosDaConta),
                  },
                  products: lerProdutosDaConta(products, {
                    seller: authUserZustand?.userInfo.userSocialName,
                    comExpandido: true,
                    productExpanded,
                  }),
                  totals: totals,
                });
              }
              else {
                resetOrderData();
              }
            } else {
              handleSetMessage(
                `Balcão ${searchValueInput.replace(
                  "Balcão ",
                  ""
                )} não encontrado.`,
                `error`
              );
              resetOrderData();
            }
          }
          break;
        case "3":
          const searchCustomerByPhoneComponent =
            selectedSaleOption.itemInfoValue.saleOptionComponents.find(
              (component) => component.componentType === "SearchCustomerByPhone"
            );
          // if (orderDataZustand.orderUuid !== "" && orderDataZustand.orderStatus === 0 && searchValueInput.replace("Fone: ", "") !== customerInfoByOrder.customerPhone) {
          //   setMessageZustand(`Cancele ou confirme a conta em preenchimento.`, `error`);
          //   return;
          // }
          if (searchCustomerByPhoneComponent) {
            const customersInfo = subsidiaryDataZustand.subsidiaryInfo.find(
              (info: any) => info.subsidiaryInfoType === 1
            );
            const customers = customersInfo ? JSON.parse(customersInfo.subsidiaryInfoValue)?.Customers : [];
            const customer = customers.find(
              (customer: any) =>
                customer.customerPhone === searchValueInput.replace("Fone: ", "")
            );
            if (!customer) {
              setCurrentModalOpen("ConfirmationModal");
              setConfirmModalOpen({
                title: `Telefone não encontrado`,
                description: `Nenhum cliente com o número informado, deseja cadastrar?`,
                confirmationAction: () => {
                  setCurrentModalOpen("CreateCustomerAddressModal");
                  setConfirmModalOpen({
                    title: "",
                    description: "",
                    confirmationAction: () => { },
                    cancelationAction: () => { },
                  });
                },
                cancelationAction: () => {
                  resetOrderData();
                  setCurrentModalOpen("");
                  setSearchValueInput("");
                  setCustomerInfoByOrder({
                    customerOrigin: "",
                    customerName: "",
                    customerAddress: "",
                    customerAddressComplement: "",
                    customerAddressObservation: "",
                    customerPhone: "",
                  });
                  setConfirmModalOpen({
                    title: "",
                    description: "",
                    confirmationAction: () => { },
                    cancelationAction: () => { },
                  });
                }
              });
            } else {
              const getOrderByCustomerPhoneResponse = await api.get(
                `orderByCustomerPhone/${searchValueInput.replace("Fone: ", "")}`
              );
              if (getOrderByCustomerPhoneResponse.data.currentOrderByPhone) {
                const infosDaConta =
                  getOrderByCustomerPhoneResponse.data.currentOrderByPhone.order
                    .orderInfo;
                const products = infosDoTipo(infosDaConta, 3);
                const productTotals = totalDosProdutos(products);
                const orderTaxs = taxasDaConta(infosDaConta);
                const productTotalsWithDiscount = totalDosProdutosComDesconto(products);
                // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos
                // seis caminhos e a mesma do cupom impresso. Card 25.
                const orderDiscount = descontoDaConta(
                  infosDaConta,
                  baseDoDesconto(products)
                );
                const totals = totaisDoBalcao({
                  orderTaxs,
                  totalDeProdutos: productTotals,
                  totalComDesconto: productTotalsWithDiscount,
                  desconto: orderDiscount,
                });
                const orderInfoCustomerAddress =
                  getOrderByCustomerPhoneResponse.data.currentOrderByPhone.orderInfo.filter(
                    (info: any) => info.orderInfoType === 9
                  )[0];
                const customerAddress = JSON.parse(orderInfoCustomerAddress.orderInfoValue);

                // let formattedAddress = customer?.customerAddresses?.map(
                //   (address: any) => {
                //     if (
                //       address.customerPlaceId ===
                //       customerAddress.customerPlaceId
                //     ) {
                //       return address.customerFormattedAddress;
                //     }
                //   }
                // );
                let formattedAddress = customerAddress?.customerAddress;
                const orderPrinted: boolean = contaFoiImpressa(infosDaConta);

                setOrderDataZustand({
                  ...orderDataZustand,
                  orderUuid: getOrderByCustomerPhoneResponse.data.currentOrderByPhone?.order.orderUuid,
                  orderCode: getOrderByCustomerPhoneResponse.data.currentOrderByPhone?.order.orderCode,
                  orderOwnerUuid: getOrderByCustomerPhoneResponse.data.currentOrderByPhone?.order.updatedByUuid.userUuid,
                  orderOwnerName:
                    getOrderByCustomerPhoneResponse.data.currentOrderByPhone?.order.updatedByUuid.userSocialName,
                  orderStatus: getOrderByCustomerPhoneResponse.data.currentOrderByPhone?.order.orderStatus,
                  orderType: "3",
                  createdAt: getOrderByCustomerPhoneResponse.data.currentOrderByPhone?.order.createdAt,
                  orderInfo: {
                    orderPrinted: orderPrinted,
                    customerUuid: customer.customerUuid,
                    customerName: customer.customerName,
                    customerAddress: customerAddress?.customerAddress,
                    customerAddressComplement:
                      customer.customerAddresses.find(
                        (address: any) =>
                          address.customerAddress ===
                          customer.customerAddress
                      )?.customerAddressComplement,
                    orderTaxs: [...orderTaxs],
                    orderPayments: lerPagamentosDaConta(infosDaConta),
                  },
                  products: lerProdutosDaConta(products, {
                    seller: authUserZustand?.userInfo.userSocialName,
                    comExpandido: true,
                    productExpanded,
                  }),
                  totals: totals,
                });

                if (!searchValueInput.startsWith("Fone: ")) {
                  setSearchValueInput(`Fone: ${searchValueInput}`);
                  if (searchInputRefType3.current) {
                    searchInputRefType3.current.value = `Fone: ${searchValueInput}`;
                  }
                }
                else {
                  if (searchInputRefType3.current) {
                    searchInputRefType3.current.value = searchValueInput;
                  }
                  setSearchValueInput(searchValueInput);
                }
                const CustomerOriginLabel = rotuloDaOrigemDoCliente(
                  customer.customerOrigin
                );

                setCustomerInfoByOrder({
                  customerOrigin: CustomerOriginLabel,
                  customerName: customer.customerName,
                  customerAddress: String(formattedAddress),
                  customerAddressComplement:
                    customerAddress?.customerAddressComplement,
                  customerAddressObservation: customerAddress?.customerAddressObservation,
                  customerPhone: customer.customerPhone,
                });
              } else if (customer.customerAddresses?.length > 1 && openNewOrder !== false) {
                setCurrentModalOpen("CustomerModal");
                setComponent();
              } else if (openNewOrder !== false) {
                const openOrderResponse = await api.post(`order`, {
                  orderOwnerUuid: authUserZustand?.userInfo.userUuid,
                  period:
                    subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid,
                  orderType: "DELIVERY",
                  orderInfo: {
                    customerUuid: customer.customerUuid,
                    // customerPlaceId:
                    //   customer.customerAddresses[0].customerPlaceId,
                    customerAddress: customer.customerAddresses[0].customerAddress,
                  },
                });
                if (openOrderResponse.status === 201) {
                  setOrderDataZustand({
                    ...orderDataZustand,
                    orderUuid:
                      openOrderResponse.data.order?.createdOrder.orderUuid,
                    orderCode:
                      openOrderResponse.data.order?.createdOrder.orderCode,
                    orderOwnerUuid:
                      openOrderResponse.data.order?.createdOrder.updatedByUuid
                        .userUuid,
                    orderOwnerName:
                      openOrderResponse.data.order?.createdOrder.updatedByUuid
                        .userSocialName,
                    orderStatus: 0,
                    orderType: "3",
                    createdAt:
                      openOrderResponse.data.order?.createdOrder?.createdAt
                    ,
                    orderInfo: {
                      customerUuid: customer.customerUuid,
                      customerName: customer.customerName,
                      // customerAddress:
                      //   customer.customerAddresses[0]
                      //     .customerFormattedAddress,
                      customerAddress:
                        customer.customerAddresses[0].customerAddress,
                      customerAddressComplement:
                        customer.customerAddresses[0]
                          .customerAddressComplement,
                      orderTaxs: [openOrderResponse.data.order?.deliveryTax],
                    },
                    products: [],
                    totals: {},
                  });
                  if (!searchValueInput.startsWith("Fone: ")) {
                    setSearchValueInput(`Fone: ${searchValueInput}`);
                    if (searchInputRefType3.current) {
                      searchInputRefType3.current.value = `Fone: ${searchValueInput}`;
                    }
                  }
                  else {
                    if (searchInputRefType3.current) {
                      searchInputRefType3.current.value = searchValueInput;
                    }
                    setSearchValueInput(searchValueInput);
                  }
                  const CustomerOriginLabel = rotuloDaOrigemDoCliente(
                    customer.customerOrigin
                  );

                  setCustomerInfoByOrder({
                    customerOrigin: CustomerOriginLabel,
                    customerName: customer.customerName,
                    //customerAddress: customer.customerAddresses[0].customerFormattedAddress,
                    customerAddress: customer.customerAddresses[0].customerAddress,
                    customerAddressComplement:
                      customer.customerAddresses[0].customerAddressComplement,
                    customerAddressObservation: customer.customerAddresses[0].customerAddressObservation,
                    customerPhone: customer.customerPhone,
                  });
                  handleSetMessage(
                    `Pedido ${openOrderResponse.data.order?.createdOrder?.orderCode} aberto com sucesso!`,
                    `success`
                  );
                  getPeriodInfo();
                }
              }
              else {
                resetOrderData();

              }
            }
          }
          break;
        default:
          break;
      }
      } catch (error: any) {
        // Uma conta que não carrega tem que DIZER que não carregou. Antes do
        // card 25 não havia try/catch nenhum aqui: quando `taxasDaConta`
        // devolvia undefined a exceção escapava, a conta não abria e a tela
        // ficava MUDA — o operador não via erro nenhum.
        if (error.message === "Network Error") {
          handleSetMessage(
            `Erro ao tentar carregar a conta, entre em contato com os administradores do Alfredo da sua unidade.`,
            `error`
          );
        } else {
          handleSetMessage(
            `Erro ao carregar a conta: ${error.message}`,
            `error`
          );
        }
      }
    }
    getPeriodInfo();
    await setComponent();
  };
  const handleSearchByOrderTable = async (
    orderUuid: UUID,
    order?: any,
    customer?: any
  ) => {
    switch (selectedSaleOption.itemInfoValue.saleOptionType) {
      case "1":
        try {
          const getOrderByIdResponse = await api.get(`order/${orderUuid}`);
          if (getOrderByIdResponse.data.currentOrderById.orderStatus < 6) {
            const deskUuid = order.orderInfo.filter(
              (info: any) => info.orderInfoType === 1
            )[0].orderInfoValue;
            const selectedDesk =
              subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodDesks?.filter(
                (desk: any) => desk.itemUuid === deskUuid
              )[0];
            if (selectedDesk) {
              setSearchValueInput(selectedDesk.itemName);
              if (searchInputRefType1.current) {
                searchInputRefType1.current.value = selectedDesk.itemName;
              }
              const currentOrderResponse = await api.get(
                `orderByItem/${selectedDesk.itemUuid}`
              );

              if (
                currentOrderResponse.data.currentOrderByItem === undefined
              ) {
                setCurrentModalOpen("OrderDeskModal");
              } else if (currentOrderResponse.data.currentOrderByItem !== undefined) {
                const infosDaConta =
                  currentOrderResponse.data.currentOrderByItem.order.orderInfo;
                const peopleNumber = infosDoTipo(infosDaConta, 2);
                const products = infosDoTipo(infosDaConta, 3);
                const peopleNumberParsed = JSON.parse(peopleNumber[0].orderInfoValue);
                const totalForAllPeopleWithDiscount = totalDaMesaComDesconto(
                  products,
                  peopleNumberParsed
                );
                // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos
                // seis caminhos e a mesma do cupom impresso. Card 25.
                // `totalDaMesaComDesconto` continua sendo o subtotal EXIBIDO.
                const orderDiscount = descontoDaConta(
                  infosDaConta,
                  baseDoDesconto(products)
                );
                const orderTaxs = taxasDaConta(infosDaConta);
                const totals = totaisDaMesa({
                  products,
                  orderTaxs,
                  lugares: peopleNumberParsed,
                  totalComDesconto: totalForAllPeopleWithDiscount,
                  desconto: orderDiscount,
                });
                const orderPrinted: boolean = contaFoiImpressa(infosDaConta);


                setOrderDataZustand({
                  orderUuid: currentOrderResponse.data.currentOrderByItem.order.orderUuid,
                  orderCode: currentOrderResponse.data.currentOrderByItem.order.orderCode,
                  orderOwnerUuid:
                    currentOrderResponse.data.currentOrderByItem.order.updatedBy,
                  orderOwnerName:
                    currentOrderResponse.data.currentOrderByItem.order.updatedByUuid
                      .userSocialName,
                  orderStatus:
                    currentOrderResponse.data.currentOrderByItem.order.orderStatus,
                  orderType: String(currentOrderResponse.data.currentOrderByItem.order.orderType),
                  createdAt: currentOrderResponse.data.currentOrderByItem.order.createdAt,
                  orderInfo: {
                    orderPrinted: orderPrinted,
                    peopleNumber: peopleNumber[0].orderInfoValue,
                    deskUuid: selectedDesk.itemUuid,
                    orderTaxs: [...orderTaxs],
                    orderPayments: lerPagamentosDaConta(infosDaConta),
                  },
                  products: lerProdutosDaConta(products, {
                    seller: authUserZustand?.userInfo.userSocialName,
                    comLugar: true,
                  }),
                  totals: totals,
                });
              }
            }


          } else {
            resetOrderData();

          }
        } catch (error: any) {
          if (error.message === "Network Error") {
            handleSetMessage(
              `Erro ao tentar carregar a conta, entre em contato com os administradores do Alfredo da sua unidade.`,
              `error`
            );
          } else {
            handleSetMessage(
              `Erro ao carregar a conta: ${error.message}`,
              `error`
            );
          }
        }
        break;
      case "2":
        try {
          const getOrderByIdResponse = await api.get(`order/${orderUuid}`);
          if (getOrderByIdResponse.data.currentOrderById.orderStatus < 6) {
            const counterUuid = order.orderInfo.filter(
              (info: any) => info.orderInfoType === 1
            )[0].orderInfoValue;
            const selectedCounter =
              subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodCounters?.filter(
                (desk: any) => desk.itemUuid === counterUuid
              )[0];
            if (selectedCounter) {
              setSearchValueInput(selectedCounter.itemName);
              if (searchInputRefType2.current) {
                searchInputRefType2.current.value = selectedCounter.itemName;
              }
              const infosDaConta =
                getOrderByIdResponse.data.currentOrderById.orderInfo;
              const products = infosDoTipo(infosDaConta, 3);
              const productTotals = totalDosProdutos(products);
              const orderTaxs = taxasDaConta(infosDaConta);
              const productTotalsWithDiscount = totalDosProdutosComDesconto(products);
              // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos
              // seis caminhos e a mesma do cupom impresso. Card 25.
              const orderDiscount = descontoDaConta(
                infosDaConta,
                baseDoDesconto(products)
              );
              const totals = totaisDoBalcao({
                orderTaxs,
                totalDeProdutos: productTotals,
                totalComDesconto: productTotalsWithDiscount,
                desconto: orderDiscount,
              });
              const orderPrinted: boolean = contaFoiImpressa(infosDaConta);

              setOrderDataZustand({
                orderUuid: getOrderByIdResponse.data.currentOrderById.orderUuid,
                orderCode: getOrderByIdResponse.data.currentOrderById.orderCode,
                orderOwnerUuid:
                  getOrderByIdResponse.data.currentOrderById.updatedBy,
                orderOwnerName:
                  getOrderByIdResponse.data.currentOrderById.updatedByUuid
                    .userSocialName,
                orderStatus:
                  getOrderByIdResponse.data.currentOrderById.orderStatus,
                orderType: String(getOrderByIdResponse.data.currentOrderById.orderType),
                createdAt: getOrderByIdResponse.data.currentOrderById.createdAt,
                orderInfo: {
                  orderPrinted: orderPrinted,
                  counterUuid: selectedCounter.itemUuid,
                  orderTaxs: [...orderTaxs],
                  orderPayments: lerPagamentosDaConta(infosDaConta),
                },
                products: lerProdutosDaConta(products, {
                  seller: authUserZustand?.userInfo.userSocialName,
                }),
                totals: totals,
              });
            }
          } else {
            resetOrderData();

          }
        } catch (error: any) {
          if (error.message === "Network Error") {
            handleSetMessage(
              `Erro ao tentar carregar a conta, entre em contato com os administradores do Alfredo da sua unidade.`,
              `error`
            );
          } else {
            handleSetMessage(
              `Erro ao carregar a conta: ${error.message}`,
              `error`
            );
          }
        }
        break;
      case "3":
        try {
          const getOrderByIdResponse = await api.get(`order/${orderUuid}`);
          if (getOrderByIdResponse.data.currentOrderById.orderStatus < 6) {
            const infosDaConta =
              getOrderByIdResponse.data.currentOrderById.orderInfo;
            const products = infosDoTipo(infosDaConta, 3);
            const productTotals = totalDosProdutos(products);
            const orderTaxs = taxasDaConta(infosDaConta);
            const productTotalsWithDiscount = totalDosProdutosComDesconto(products);
            // A base do percentual é `baseDoDesconto` (BRUTA), a mesma dos
            // seis caminhos e a mesma do cupom impresso. Card 25.
            const orderDiscount = descontoDaConta(
              infosDaConta,
              baseDoDesconto(products)
            );
            const totals = totaisDoBalcao({
              orderTaxs,
              totalDeProdutos: productTotals,
              totalComDesconto: productTotalsWithDiscount,
              desconto: orderDiscount,
            });
            const orderPrinted: boolean = contaFoiImpressa(infosDaConta);

            setOrderDataZustand({
              ...orderDataZustand,
              orderUuid: getOrderByIdResponse.data.currentOrderById.orderUuid,
              orderCode: getOrderByIdResponse.data.currentOrderById.orderCode,
              orderOwnerUuid: getOrderByIdResponse.data.currentOrderById.updatedByUuid.userUuid,
              orderOwnerName:
                getOrderByIdResponse.data.currentOrderById.updatedByUuid.userSocialName,
              orderStatus: getOrderByIdResponse.data.currentOrderById.orderStatus,
              orderType: "3",
              createdAt: getOrderByIdResponse.data.currentOrderById.createdAt,
              orderInfo: {
                customerUuid: customer.customerUuid,
                customerName: customer.customerName,
                customerAddress: customer.customerAddress,
                orderPrinted: orderPrinted,
                //customerAddress: customer.customerFormattedAddress,
                customerAddressComplement:
                  customer.customerAddressComplement,
                customerAddressObservation: customer.customerAddressObservation,
                orderTaxs: [...orderTaxs],
                orderPayments: lerPagamentosDaConta(infosDaConta),
              },
              products: lerProdutosDaConta(products, {
                seller: authUserZustand?.userInfo.userSocialName,
              }),
              totals: totals,
            });

            setSearchValueInput(`Fone: ${customer.customerPhone}`);

            if (searchInputRefType3.current) {
              searchInputRefType3.current.value = `Fone: ${customer.customerPhone}`;
            }

            const CustomerOriginLabel = rotuloDaOrigemDoCliente(
              customer.customerOrigin
            );

            setCustomerInfoByOrder({
              customerOrigin: CustomerOriginLabel,
              customerName: customer.customerName,
              customerAddress: customer.customerAddress,
              //customerAddress: customer.customerFormattedAddress,
              customerAddressComplement:
                customer.customerAddressComplement,
              customerAddressObservation: customer.customerAddressObservation,
              customerPhone: customer.customerPhone,
            });
          } else {
            resetOrderData();


          }

        } catch (error: any) {
          if (error.message === "Network Error") {
            handleSetMessage(
              `Erro ao tentar carregar a conta, entre em contato com os administradores do Alfredo da sua unidade.`,
              `error`
            );
          } else {
            handleSetMessage(
              `Erro ao carregar a conta: ${error.message}`,
              `error`
            );
          }
        }
        break;
      default:
    }
    await setComponent();
  };

  //Funcoes para o campo de ultimos pedidos do delivery
  const addProductFromLastOrder = async (lastProduct: any) => {
    if (orderDataZustand && lastProduct) {
      let productPriceWithoutObservations = Number(lastProduct.productPrice);
      if (lastProduct.productObservations?.length > 0) {
        const lastProductObservations = lastProduct.productObservations
        productPriceWithoutObservations = productPriceWithoutObservations - lastProductObservations.reduce(
          (acc: number, observation: any) => acc + observation.observationPrice,
          0
        );
      }
      if (lastProduct.productDiscount) {
        productPriceWithoutObservations = productPriceWithoutObservations - Number(lastProduct.productDiscount);
      }
      const productOrderData = {
        orderType: `DELIVERY`,
        productUuid: lastProduct.productUuid,
        productCode: String(lastProduct.productCode),
        productPrinted: false,
        productName: lastProduct.productName,
        productPrice: Number(productPriceWithoutObservations),
        productDiscount: "0",
      };

      try {
        await api.post(`addProductOrder/${orderDataZustand.orderUuid}`, productOrderData);
      } catch (error: any) {
        if (error.message === "Network Error") {
          handleSetMessage(
            `Erro ao tentar incluir produto, entre em contato com os administradores do Alfredo da sua unidade.`,
            `error`
          );
        } else {
          handleSetMessage(
            `Erro ao incluir produto: ${error.message}`,
            `error`
          );
        }
      }
      handleSearch();
    }
  };
  const addProductObservationFromLastOrder = async (lastProductObservation: any) => {
    const selectedProducts = orderDataZustand.products?.filter(
      (product: any) => product.productSelected || product.productSemiSelected
    );
    if (orderDataZustand && selectedProducts) {
      selectedProducts?.forEach(async (product: any) => {
        const productObservation = [{
          observationUuid: lastProductObservation.observationUuid,
          observationName: lastProductObservation.observationName,
          observationPrice: lastProductObservation.observationPrice,
        }]

        const productObservations = [
          ...(product.productObservations ?? []),
          ...productObservation,
        ];

        const orderInfoUpdated: any = {
          productCode: Number(product.productCode),
          productUuid: product.productUuid,
          productPrinted: product.productPrinted,
          productName: product.productName,
          productPrice: Number(product.productPrice.replace(",", ".")) +
            productObservations.reduce(
              (acc: number, observation: any) =>
                acc + (observation.observationPrice || 0),
              0
            ),
          productObservations: productObservations,
        };

        try {
          api.post(
            `addProductObservation/${product.productOrderUuid}`,
            orderInfoUpdated
          );
          handleSetMessage("Observações adicionadas com sucesso!", "success");
        } catch (err) {
          handleSetMessage("Erro ao adicionar observações!", "error");
        }
      });
      handleSearch(false, true);
    }
  };

  const handleLastOrdersRowClick = async (order: any) => {
    await setLastOrderSelected(order);
    getPeriodInfo();

  };
  const handleRemoveLastOrder = async () => {
    await setLastOrderSelected(null);
    getPeriodInfo();
  };

  //#endregion

  //#region Verificar se o pedido possui pagamentos e calcular o troco
  let [paybackValue, setPaybackValue] = useState(0);

  const handlePayback = async (payback: number) => {
    await setPaybackValue(payback);
    setCurrentModalOpen("PaybackModal");
  }
  //#endregion

  //#region Criar os componentes em tela com base no que foi definido no back-end e com base na opcao de venda acessada.
  //Parametro de componentes exibidos na tela
  const [content, setContent] = useState<JSX.Element[]>([]);

  //Opcao de venda atual
  const { saleOption } = useParams();

  const selectedSaleOption =
    subsidiaryDataZustand.selectedPdv.saleOptions.filter(
      (item) => item.itemInfoUuid === saleOption
    )[0];

  //Funcoes disponíveis do Alfredo OPS para uso dos botoes da opcao de venda
  const handleButtonClick = (Action: string, event?: React.MouseEvent) => {

    switch (Action) {
      case "AddProduct":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de adicionar um produto.`,
            `error`
          );
          return;
        } else if (orderDataZustand.orderStatus === 5) {
          handleSetMessage(
            `Você precisa desbloquear a conta antes de adicionar um produto.`,
            `error`
          );
          return;
        } else {
          setCurrentModalOpen("AddProductModal");
          setComponent();
        }
        break;
      case "AddObservation":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de adicionar observações de um produto.`,
            `error`
          );
        } else if (
          orderDataZustand.products?.filter(
            (product: any) => product.productSelected
          ).length === 0 &&
          orderDataZustand.products?.filter(
            (product: any) => product.productSemiSelected
          ).length === 0
        ) {
          handleSetMessage(
            `Você precisa selecionar um produto para adicionar uma observação.`,
            `error`
          );
        }
        else if (orderDataZustand.orderStatus === 5) {
          handleSetMessage(
            `Você precisa desbloquear a conta antes de adicionar um produto.`,
            `error`
          );
          return;
        } else {
          setCurrentModalOpen("AddObservationModal");
          setComponent();
        }
        break;
      case "CancelOrder":
        const selectedProducts = orderDataZustand.products?.filter(
          (product: any) => product.productSelected || product.productSemiSelected
        );
        const selectedObservations = orderDataZustand.products?.flatMap(
          (product: any) => (product.productObservations || []).filter(
            (observation: any) => observation.observationSelected
          )
        ) || [];

        let actionTitle = "";
        let actionDescription = "";

        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de remover um produto.`,
            `error`
          );
        } else if (Number(orderDataZustand.orderStatus) >= 4 && orderDataZustand.orderType !== "3") {
          handleSetMessage(
            `Você precisa desbloquear a conta antes de remover um produto.`,
            `error`
          );
        }
        else if (Number(orderDataZustand.orderStatus) >= 2 &&
          orderDataZustand.orderType === "3") {
          actionTitle = "Cancelar Pedido";
          actionDescription = "Deseja cancelar o pedido?";
          setCurrentModalOpen("ConfirmationModal");
          setConfirmModalOpen({
            title: actionTitle,
            description: actionDescription,
            confirmationAction: () => {
              setCurrentModalOpen("CancelOrderModal");
              setConfirmModalOpen({
                title: "",
                description: "",
                confirmationAction: () => { },
                cancelationAction: () => { },
              });
            },
            cancelationAction: () => { },
          });
        }
        else if (
          selectedProducts?.length === 0 &&
          selectedObservations?.length === 0
        ) {
          handleSetMessage(
            `Você precisa selecionar um produto para remover.`,
            `error`
          );
        }
        else if (selectedSaleOption.itemInfoValue.saleOptionType === "3" && orderDataZustand.orderStatus === 0) {
          const selectedProductsAndObservations = orderDataZustand.products?.filter(
            (product: any) =>
              product.productSelected ||
              product.productSemiSelected ||
              (product.productObservations || []).some(
                (observation: any) => observation.observationSelected
              )
          );
          function handleErrorMessage(error: any) {
            if (error.message === "Network Error") {
              handleSetMessage(
                `Erro ao tentar remover produto, entre em contato com os administradores do Alfredo da sua unidade.`,
                `error`
              );
            } else {
              handleSetMessage(
                `Erro ao remover produto: ${error.message}`,
                `error`
              );
            }
          }

          selectedProductsAndObservations?.forEach(product => {
            const hasSelectedObservations = product.productObservations?.some((observation: any) => observation.observationSelected);
            if (hasSelectedObservations) {
              product.productObservations?.forEach(observation => {
                if (!observation.observationSelected) {
                  return;
                }
                try {
                  api.post(`removeProductObservation/${orderDataZustand.orderUuid}`, {
                    productOrderUuid: String(product.productOrderUuid),
                    productObservationUuid: String(observation.observationUuid),
                    productObservationProduced: Boolean(observation.observationSelected),
                    cancelReasonUuid: "00000000-0000-0000-0000-000000000000",
                  });
                } catch (error: any) {
                  handleErrorMessage(error);
                }
              });
            }
            else {
              try {
                api.post(`removeProductOrder/${orderDataZustand.orderUuid}`, {
                  products: [
                    {
                      orderInfoUuid: product.productOrderUuid,
                      cancelReasonUuid: "00000000-0000-0000-0000-000000000000",
                      productProduced: false,
                      observations: [], // Mesmo que não tenha observações, envie um array vazio
                    },
                  ],
                });
                handleSearch();
              } catch (error: any) {
                handleErrorMessage(error);
              }
            }
          });

          // // Verifica se todos os produtos da conta foram removidos
          // if (selectedProductsAndObservations?.length === orderDataZustand.products?.length) {
          //   try {
          //     api.post(`cancelOrder/${orderDataZustand.orderUuid}`);
          //     handleSetMessage(`Conta encerrada com sucesso!`, `success`);
          //     handleSearch();
          //     setCurrentModalOpen("");
          //   } catch (error: any) {
          //     handleErrorMessage(error);
          //   }
          // }
          handleSetMessage(`Cancelado com sucesso!`, `success`);
          handleSearch(false, true);
          setCurrentModalOpen("");
          setConfirmModalOpen({
            title: "",
            description: "",
            confirmationAction: () => { },
            cancelationAction: () => { },
          });
        }

        else if (selectedProducts && selectedObservations) {
          if (selectedProducts?.length > 0 || selectedObservations?.length > 0) {
            if (selectedProducts?.length === orderDataZustand.products?.length && selectedObservations?.length === 0) {
              actionTitle = "Cancelar Conta";
              actionDescription = "Deseja cancelar a conta?";
            }
            else if (selectedProducts?.length === 1 && selectedObservations?.length === 0) {
              actionTitle = "Cancelar Produto";
              actionDescription = "Deseja cancelar o produto selecionado?";
            } else if (selectedProducts?.length > 1 && selectedObservations?.length === 0) {
              actionTitle = "Cancelar Produtos";
              actionDescription = "Deseja cancelar os produtos selecionados?";
            } else if (selectedObservations?.length === 1) {
              actionTitle = "Cancelar Observação";
              actionDescription = "Deseja cancelar a observação selecionada?";
            } else if (selectedObservations?.length > 1) {
              actionTitle = `Cancelar Observações`;
              actionDescription = "Deseja cancelar as observações selecionadas?";
            } else {
              actionTitle = "Cancelar Conta";
              actionDescription = "Deseja cancelar a conta?";
            }

            setCurrentModalOpen("ConfirmationModal");
            setConfirmModalOpen({
              title: actionTitle,
              description: actionDescription,
              confirmationAction: () => {
                setCurrentModalOpen("CancelOrderModal");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              },
              cancelationAction: () => { },
            });
          }
        }
        break;
      case "ChangeEntity":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de transferir.`,
            `error`
          );
        } else if (orderDataZustand.orderStatus === 5) {
          handleSetMessage(
            `Você precisa desbloquear a conta antes de transferir.`,
            `error`
          );
        } else if (
          orderDataZustand.products?.filter(
            (product: any) => product.productSelected
          ).length === 0 &&
          orderDataZustand.products?.filter(
            (product: any) => product.productSemiSelected
          ).length === 0
        ) {
          handleSetMessage(
            `Você precisa selecionar um produto para transferir.`,
            `error`
          );
        } else {
          if (selectedSaleOption.itemInfoValue.saleOptionType === "1") {

            const fetchAvailableDesks = async () => {
              const tempAvailableDesks = [];
              try {
                const desksResponse = await api.get(`itensAvailable/4`);
                const desks = desksResponse.data.currentItensAvailable;
                if (desks?.length > 0) {
                  for (const desk of desks) {
                    if (desk.itemUuid !== orderDataZustand.orderInfo.deskUuid) {
                      tempAvailableDesks.push({
                        itemUuid: desk.itemUuid,
                        itemName: desk.itemName,
                        itemOrder: desk.itemOrder,
                      });
                    }
                  }
                  setAvailableDesks(tempAvailableDesks);
                }
              } catch (error: any) {
                handleSetMessage(
                  `Erro ao buscar mesas disponíveis: ${error.message}`,
                  `error`
                );
              }
            };

            fetchAvailableDesks();
            setCurrentModalOpen("TransferOrderDeskModal");
          } else {
            const fetchAvailableCounters = async () => {
              const tempAvailableCounters = [];
              try {

                const countersResponse = await api.get(`itensAvailable/5`);
                const counters = countersResponse.data.currentItensAvailable;
                if (counters?.length > 0) {
                  for (const counter of counters) {
                    if (counter.itemUuid !== orderDataZustand.orderInfo.counterUuid) {
                      tempAvailableCounters.push({
                        itemUuid: counter.itemUuid,
                        itemName: counter.itemName,
                        itemOrder: counter.itemOrder,
                      });
                    }
                  }
                  setAvailableCounters(tempAvailableCounters);
                }
              } catch (error: any) {
                handleSetMessage(
                  `Erro ao buscar mesas disponíveis: ${error.message}`,
                  `error`
                );
              }
            };

            fetchAvailableCounters();
            setCurrentModalOpen("TransferOrderCounterModal");
          }
          setComponent();
        }
        break;
      case "PrintProduct":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de imprimir a via de produção.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ConfirmationModal");
        setConfirmModalOpen({
          title: `Produzir Pedido?`,
          description: `Deseja informar para a cozinha os itens do pedido?`,
          confirmationAction: async () => {
            handleSearch(false, false);

            setCurrentModalOpen("");
            setConfirmModalOpen({
              title: "",
              description: "",
              confirmationAction: () => { },
              cancelationAction: () => { },
            });
            // if (!orderDataZustand?.orderPrinted) {
            //   api.post(
            //     `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption.itemInfoValue.saleOptionPrinterAddress}`
            //   );
            // }
            api.post(
              `printProduction/${orderDataZustand.orderUuid}/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodType}`
            );


            let updatedOrderInfo = orderDataZustand?.orderInfo;
            if (Array.isArray(orderDataZustand?.orderInfo)) {
              updatedOrderInfo = orderDataZustand.orderInfo.map((info: any) => {
                if (info.orderInfoType === 14) {
                  return {
                    ...info,
                    orderInfoValue: true,
                  };
                }
                return info;
              });
            } else if (orderDataZustand?.orderInfo && typeof orderDataZustand.orderInfo === 'object') {
              updatedOrderInfo = {
                ...orderDataZustand.orderInfo,
                orderPrinted: true,
              };
            }

            setOrderDataZustand({
              ...orderDataZustand,
              orderStatus: 2,
              orderInfo: updatedOrderInfo,
            });
            handleSetMessage(
              `Pedido enviado para produção com sucesso!`,
              `success`
            );
            getPeriodInfo();
          },
          cancelationAction: () => { },
        });
        break;
      case "ChangeOrderStatus":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de mudar de status.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ConfirmationModal");
        setConfirmModalOpen({
          title:
            orderDataZustand.orderStatus === 5
              ? `Desbloquear Conta`
              : `Bloquear Conta`,
          description:
            orderDataZustand.orderStatus === 5
              ? `Desbloqueie a conta para que o cliente possa fazer novos pedidos.`
              : `Bloqueie a conta para que o cliente não possa fazer novos pedidos.`,
          confirmationAction: async () => {
            if (orderDataZustand.orderStatus === 5) {
              try {
                api.patch(`/order/${orderDataZustand.orderUuid}`, {
                  orderStatus: 1,
                });

                await setOrderDataZustand({
                  ...orderDataZustand,
                  orderStatus: 1,
                });

                handleSetMessage(`Conta desbloqueada com sucesso!`, `success`);
                setCurrentModalOpen("");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              } catch (error: any) {
                if (error.message === "Network Error") {
                  handleSetMessage(
                    `Erro ao tentar alterar status da conta, entre em contato com os administradores do Alfredo da sua unidade.`,
                    `error`
                  );
                } else {
                  handleSetMessage(
                    `Erro ao alterar status da conta: ${error.message}`,
                    `error`
                  );
                }
              }
            } else {
              try {
                api.patch(`/order/${orderDataZustand.orderUuid}`, {
                  orderStatus: 5,
                });

                await setOrderDataZustand({
                  ...orderDataZustand,
                  orderStatus: 5,
                });

                handleSetMessage(`Conta bloqueada com sucesso!`, `success`);
                setCurrentModalOpen("");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              } catch (error: any) {
                if (error.message === "Network Error") {
                  handleSetMessage(
                    `Erro ao tentar alterar status da conta, entre em contato com os administradores do Alfredo da sua unidade.`,
                    `error`
                  );
                } else {
                  handleSetMessage(
                    `Erro ao alterar status da conta: ${error.message}`,
                    `error`
                  );
                }
              }
            }
          },
          cancelationAction: () => { },
        });
        break;
      case "PrintOrderInfo":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de imprimir a via de conferência.`,
            `error`
          );
          return;
        }
        else if (!orderDataZustand?.products || orderDataZustand.products.length === 0) {
          handleSetMessage(
            `Não há produtos na conta para imprimir.`,
            `error`
          );
          return;
        }

        handleSearch(false, false);

        const uniquePeopleNumbers = new Set(
          orderDataZustand?.products?.map((product) => product.people ?? "0")
        );

        setPeopleWithProducts(
          Array.from(
            new Set(
              orderDataZustand?.products
                ?.filter((product) => product.people)
                ?.map((product) => product.people)
            )
          )
            .sort((a, b) => parseInt(a as string) - parseInt(b as string))
            .map((person, index) => ({
              key: `${index + 1}`,
              label: `Lugar ${person}`,
              value: `${person}`,
            })) || []
        );

        if (uniquePeopleNumbers.size > 1) {
          // Caso existam produtos vinculados a diferentes pessoas, exibe o customAlertWithPickerSelect
          setCurrentModalOpen("PrintOrder");
        } else {
          debugger;

          api.post(
            `printOrder/${orderDataZustand.orderUuid}/${selectedSaleOption.itemInfoValue.saleOptionPrinterAddress}`
          );
          api.patch(`/order/${orderDataZustand.orderUuid}`, {
            orderStatus: 5,
          });

          setMessageZustand(`Conta impressa com sucesso!`, `success`);

          setTimeout(() => handleSearch(false, false), 4000);

        }
        break;
      case "AddDiscount":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de adicionar um desconto.`,
            `error`
          );
          return;
        }
        else if (orderDataZustand.orderStatus === 5) {
          handleSetMessage(
            `Você precisa desbloquear a conta antes de adicionar um desconto.`,
            `error`
          );
          return;
        }
        else {
          setCurrentModalOpen("AddDiscountModal");
          setComponent();
          break;
        }
      case "ReviewOrderTax":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(
            `Você precisa abrir uma conta antes de adicionar uma taxa.`,
            `error`
          );
          return;
        }
        else if (orderDataZustand.orderStatus === 5) {
          handleSetMessage(
            `Você precisa desbloquear a conta antes de adicionar uma taxa.`,
            `error`
          );
          return;
        }
        setCurrentModalOpen("ReviewOrderTaxModal");
        setComponent();
        break;
      case "AddPayment":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(`Você precisa abrir uma conta antes.`, `error`);
          return;
        }
        if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
          switch (orderDataZustand.orderStatus) {
            case 0:
              if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
                if (orderDataZustand?.products?.length === 0) {
                  handleSetMessage(
                    `Você precisa adicionar produtos antes.`,
                    `error`
                  );
                  return;

                }
                setLastOrderSelected("");
                setCurrentModalOpen("AddPaymentModal");
              }
              else {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Confirmar Pedido?`,
                  description: `Deseja informar para o cliente a confirmação do pedido?`,
                  confirmationAction: () => {
                    setCurrentModalOpen("");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    setOrderDataZustand({
                      ...orderDataZustand,
                      orderStatus: 1,
                    });
                    handleSetMessage(
                      `Pedido confirmado com sucesso!`,
                      `success`
                    );
                  },
                  cancelationAction: () => { },
                });
              }
              break;
            case 1:
              if (orderDataZustand?.products?.length === 0) {
                handleSetMessage(
                  `Você precisa adicionar produtos antes.`,
                  `error`
                );
                return;

              }
              setCurrentModalOpen("AddPaymentModal");
              break;
            case 2:
              if (selectedSaleOption.itemInfoValue.saleOptionType === "3") {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Confirmar Envio do Pedido?`,
                  description: `Confirme se todos os itens do pedido estão sendo enviados.`,
                  confirmationAction: () => {
                    setCurrentModalOpen("sendToDeliveryModal");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    getPeriodInfo();
                  },
                  cancelationAction: () => { },
                });
              }
              else {
                setCurrentModalOpen("ConfirmationModal");
                setConfirmModalOpen({
                  title: `Confirmar Produção dos Produtos?`,
                  description: `Deseja informar para que os produtos estão prontos?`,
                  confirmationAction: () => {
                    setCurrentModalOpen("");
                    setConfirmModalOpen({
                      title: "",
                      description: "",
                      confirmationAction: () => { },
                      cancelationAction: () => { },
                    });
                    setOrderDataZustand({
                      ...orderDataZustand,
                      orderStatus: 3,
                    });
                    handleSetMessage(
                      `Pedido confirmado com sucesso!`,
                      `success`
                    );
                  },
                  cancelationAction: () => { },
                });
              }
              break;
            case 3:
              setCurrentModalOpen("ConfirmationModal");
              setConfirmModalOpen({
                title: `Confirmar Envio do Pedido?`,
                description: `Confirme se todos os itens do pedido estão sendo enviados.`,
                confirmationAction: () => {
                  setCurrentModalOpen("sendToDeliveryModal");
                  setConfirmModalOpen({
                    title: "",
                    description: "",
                    confirmationAction: () => { },
                    cancelationAction: () => { },
                  });
                },
                cancelationAction: () => { },
              });
              break;
            case 4:
              setCurrentModalOpen("AddPaymentModal");
              break;
            default:
              break;
          }
        } else {
          if (orderDataZustand?.products?.length === 0) {
            setCurrentModalOpen("ConfirmationModal");
            setConfirmModalOpen({
              title: `Conta não iniciada`,
              description: `A conta ainda não foi iniciada, deseja encerrar?`,
              confirmationAction: () => {
                api.post(`closeOrder/${orderDataZustand.orderUuid}`);
                handleSetMessage(`Conta encerrada com sucesso!`, `success`);
                resetOrderData();


                setCurrentModalOpen("");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              },
              cancelationAction: () => { },
            });
          } else if (!orderDataZustand?.orderInfo?.orderPrinted) {
            setCurrentModalOpen("ConfirmationModal");
            setConfirmModalOpen({
              title: `Conta não impressa`,
              description: `Via de conferência da conta ainda não foi impressa, deseja continuar?`,
              confirmationAction: () => {
                setCurrentModalOpen("AddPaymentModal");
                setConfirmModalOpen({
                  title: "",
                  description: "",
                  confirmationAction: () => { },
                  cancelationAction: () => { },
                });
              },
              cancelationAction: () => { },
            });
          } else {
            setCurrentModalOpen("AddPaymentModal");
          }
        }

        break;
      case "PartialWithdrawal":
        setCurrentModalOpen("PartialWithdrawalModal");
        setComponent();
        break;
      case "PeriodContent":
        setCurrentModalOpen("PeriodContentModal");
        setComponent();
        break;
      case "AccessOrders":
        setCurrentModalOpen("PeriodOrdersModal");
        setComponent();
        break;
      case "ReviewOrderInfo":
        if (orderDataZustand.orderUuid === "") {
          handleSetMessage(`Você precisa abrir uma conta antes.`, `error`);
          return;
        }
        setCurrentModalOpen("ReviewOrderInfoModal");
        setComponent();
        break;
      case "AllOptions":
        if (event) {
          setModalPosition({
            top: event.clientY - 100,
            left: event.clientX + 170,
          });
        }
        //setAllOptionsOpen(true);
        setCurrentModalOpen("AllOptionsModal");
        break;
      case "BackToHome":
        resetOrderData();


        window.location.href = "/";
        break;
    }
  };
  const getComboProductInfo = (productUuid: any) => {
    const products =
      subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo?.periodProducts?.Products ?? [];
    return products.find((product: { productUuid: string }) => product.productUuid === productUuid) || null;
  };
  //Criar componentes com base no SaleOption atual
  const requestSaleOptionInfo = async () => {
    const newContent =
      selectedSaleOption?.itemInfoValue?.saleOptionComponents?.map(
        (component: any) => {
          const { componentType, componentStatus, componentProps } = component;
          const { buttonLabel, buttonBrightness } = rotuloDoBotao(
            componentProps,
            orderDataZustand
          );
          if (componentStatus === false) {
            return null;
          }
          dragAndDrop(component, component.componentSelected);
          switch (componentType) {
            case "RightMenu":
              return (
                <MenuLateral
                  component={component}
                  componentProps={componentProps}
                  selectedSaleOption={selectedSaleOption}
                />
              );
            case "Button":
              return (
                <BotaoDeAcao
                  component={component}
                  componentProps={componentProps}
                  buttonLabel={buttonLabel}
                  handleButtonClick={handleButtonClick}
                />
              );
            case "OrderButton":
              return (
                <BotaoDePedido
                  component={component}
                  componentProps={componentProps}
                  buttonLabel={buttonLabel}
                  buttonBrightness={buttonBrightness}
                  orderDataZustand={orderDataZustand}
                  handleButtonClick={handleButtonClick}
                />
              );
            case "Divider":
              break;
            case "Header":
              break;
            case "PeriodInfoLabel":
              return (
                <RotuloDoPeriodo
                  component={component}
                  componentProps={componentProps}
                  subsidiaryDataZustand={subsidiaryDataZustand}
                  authUserZustand={authUserZustand}
                  currentDate={currentDate}
                  greetingMessage={greetingMessage}
                />
              );
            case "OrderInfoLabel":
              return (
                <RotuloDaConta
                  component={component}
                  componentProps={componentProps}
                  orderDataZustand={orderDataZustand}
                  subsidiaryDataZustand={subsidiaryDataZustand}
                  lastOrderSelected={lastOrderSelected}
                  handleLastOrdersRowClick={handleLastOrdersRowClick}
                  handleRemoveLastOrder={handleRemoveLastOrder}
                  addProductFromLastOrder={addProductFromLastOrder}
                  addProductObservationFromLastOrder={addProductObservationFromLastOrder}
                />
              );
            case "ProductTable":
              return (
                <TabelaDeProdutos
                  component={component}
                  componentProps={componentProps}
                  orderDataZustand={orderDataZustand}
                  setOrderDataZustand={setOrderDataZustand}
                  getComboProductInfo={getComboProductInfo}
                />
              );
            case "TotalTable":
              return (
                <TabelaDeTotais
                  component={component}
                  componentProps={componentProps}
                  orderDataZustand={orderDataZustand}
                />
              );
            case "SearchDesk":
              return (
                <BuscaDeMesa
                  component={component}
                  componentProps={componentProps}
                  buttonLabel={buttonLabel}
                  searchValueInput={searchValueInput}
                  setSearchValueInput={setSearchValueInput}
                  searchInputRefType1={searchInputRefType1}
                  handleSearch={handleSearch}
                  setComponent={setComponent}
                />
              );
            case "SearchCounter":
              return (
                <BuscaDeBalcao
                  component={component}
                  componentProps={componentProps}
                  buttonLabel={buttonLabel}
                  searchValueInput={searchValueInput}
                  setSearchValueInput={setSearchValueInput}
                  searchInputRefType2={searchInputRefType2}
                  handleSearch={handleSearch}
                  setComponent={setComponent}
                />
              );
            case "SearchCustomerByPhone":
              return (
                <BuscaDeClientePorTelefone
                  component={component}
                  componentProps={componentProps}
                  buttonLabel={buttonLabel}
                  searchValueInput={searchValueInput}
                  setSearchValueInput={setSearchValueInput}
                  searchInputRefType3={searchInputRefType3}
                  handleSearch={handleSearch}
                  setComponent={setComponent}
                  customerInfoByOrder={customerInfoByOrder}
                  orderDataZustand={orderDataZustand}
                  setCurrentModalOpen={setCurrentModalOpen}
                  setCustomerAddressToUpdate={setCustomerAddressToUpdate}
                  setMessageZustand={setMessageZustand}
                />
              );
            case "CustomerNameLabel":
              return (
                <RotuloDoCliente
                  component={component}
                  componentProps={componentProps}
                  valor={customerInfoByOrder.customerName}
                  titulo={"Nome do Cliente"}
                />
              );
            case "CustomerAddressLabel":
              return (
                <RotuloDoCliente
                  component={component}
                  componentProps={componentProps}
                  valor={customerInfoByOrder.customerAddress}
                  titulo={"Endereço do Cliente"}
                />
              );
            case "CustomerAddressComplementLabel":
              return (
                <RotuloDoCliente
                  component={component}
                  componentProps={componentProps}
                  valor={customerInfoByOrder.customerAddressComplement}
                  titulo={"Complemento"}
                />
              );
            case "CustomerAddressObservationLabel":
              return (
                <RotuloDoCliente
                  component={component}
                  componentProps={componentProps}
                  valor={customerInfoByOrder.customerAddressObservation}
                  titulo={"Observações"}
                />
              );
            case "CustomerOriginLabel":
              return (
                <RotuloDoCliente
                  component={component}
                  componentProps={componentProps}
                  valor={customerInfoByOrder.customerOrigin}
                  titulo={"Origem do Cliente"}
                />
              );
            case "CurrentDeskOrdersTable":
              return (
                <TabelaDePedidosDeMesa
                  component={component}
                  componentProps={componentProps}
                  subsidiaryDataZustand={subsidiaryDataZustand}
                  ordersTypeTable={ordersTypeTable}
                  setOrdersTypeTable={setOrdersTypeTable}
                  handleSearchByOrderTable={handleSearchByOrderTable}
                  getPeriodInfo={getPeriodInfo}
                />
              );
            case "CurrentPickupOrdersTable":
              return (
                <TabelaDePedidosDeBalcao
                  component={component}
                  componentProps={componentProps}
                  subsidiaryDataZustand={subsidiaryDataZustand}
                  ordersTypeTable={ordersTypeTable}
                  setOrdersTypeTable={setOrdersTypeTable}
                  handleSearchByOrderTable={handleSearchByOrderTable}
                  getPeriodInfo={getPeriodInfo}
                />
              );
            case "CurrentDeliveryOrdersTable":
              return (
                <TabelaDePedidosDeDelivery
                  component={component}
                  componentProps={componentProps}
                  subsidiaryDataZustand={subsidiaryDataZustand}
                  ordersTypeTable={ordersTypeTable}
                  setOrdersTypeTable={setOrdersTypeTable}
                  handleSearchByOrderTable={handleSearchByOrderTable}
                  getPeriodInfo={getPeriodInfo}
                />
              );

            default:
              return null;
          }
        }
      );
    await setContent(newContent as JSX.Element[]);
    setComponent();
  }

  //Funcao para ativar o Drag and Drop para os campos criados.
  function dragAndDrop(
    component: {
      componentId: string;
      componentSelected: boolean;
      componentProps: {
        componentPosition: { x: string; y: string };
      };
    },
    enable: boolean
  ) {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const draggableComponent = document.getElementById(component.componentId);

    if (draggableComponent) {
      if (enable) {
        draggableComponent.draggable = true;

        draggableComponent.addEventListener("dragstart", (event: any) => {
          event.dataTransfer.setData("text/plain", component.componentId);
        });

        draggableComponent.addEventListener("dragend", (event) => {
          const updatedSaleOptions =
            subsidiaryDataZustand.selectedPdv.saleOptions.map((option) => {
              if (option.itemInfoUuid === saleOption) {
                return {
                  ...option,
                  itemInfoValue: {
                    ...option.itemInfoValue,
                    saleOptionComponents:
                      option.itemInfoValue.saleOptionComponents.map(
                        (currentComponent) => {
                          if (
                            currentComponent.componentId ===
                            component.componentId
                          ) {
                            return {
                              ...currentComponent,
                              componentProps: {
                                ...currentComponent.componentProps,
                                componentPosition: {
                                  ...currentComponent.componentProps
                                    .componentPosition,
                                  x: (event.clientX / windowWidth) * 100 + "%",
                                  y: (event.clientY / windowHeight) * 100 + "%",
                                },
                              },
                            };
                          }
                          return currentComponent;
                        }
                      ),
                  },
                };
              }
              return option;
            });

          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: {
              ...subsidiaryDataZustand.selectedPdv,
              saleOptions: updatedSaleOptions,
            },
          });
        });
      } else {
        draggableComponent.draggable = false;
      }
    }
  }
  //#endregion

  //#region Manter o campo de busca em foco.
  //Parametro do campo em foco
  function setComponent() {
    const focusComponent =
      selectedSaleOption.itemInfoValue.saleOptionComponents.find(
        (component) => component.componentProps.componentFocus === true
      );
    if (focusComponent && currentModalOpen === "") {
      const htmlComponent = document.getElementById(
        focusComponent.componentId
      ) as HTMLInputElement;
      if (htmlComponent) {
        htmlComponent.focus();
        if (
          htmlComponent.value.includes("Mesa") ||
          htmlComponent.value.includes("Balcão") ||
          htmlComponent.value.includes("Fone")
        ) {
          htmlComponent.select();
        }
      }
    } else if (focusComponent) {
      const htmlComponent = document.getElementById(focusComponent.componentId);
      if (htmlComponent) {
        htmlComponent.blur();
      }
    }
  }
  setTimeout(() => {
    setComponent();
  }, 500);
  //#endregion

  //#region Formatar data e hora, Calcular duracao e mensagem de saudacao
  //Formatacao de data e hora e mensagem de saudacao
  const currentDate = new Date().toLocaleDateString("pt-BR");
  const currentHour = new Date().getHours();
  const greetingMessage = mensagemDeSaudacao(currentHour);
  //#endregion

  //#region Recuperar as informacoes sobre o Unidade e Período atuais
  //Obter informacoes do periodo atual
  const [isSubmitting, setIsSubmitting] = useState(false);
  const getPeriodInfo = useCallback(
    async (onlyOrders = false) => {
      if (isSubmitting) return; // Evita chamadas simultâneas

      setIsSubmitting(true);

      try {
        if (onlyOrders) {
          const periodOrdersResponse = await api.get(
            `periodOrders/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid}`
          );

          const periodOrders = periodOrdersResponse.data.periodOrders;

          setSubsidiaryDataZustand({
            ...subsidiaryDataZustand,
            selectedPdv: {
              ...subsidiaryDataZustand.selectedPdv,
              selectedPeriod: {
                ...subsidiaryDataZustand.selectedPdv.selectedPeriod,
                periodInfo: {
                  ...subsidiaryDataZustand.selectedPdv.selectedPeriod.periodInfo,
                  periodOrders: periodOrders as any[],
                }
              }
            }
          })

        } else {
          const [subsidiaryInfoResponse, periodInfoResponse] =
            await Promise.all([
              api.get("/subsidiaryInfo/2"),
              api.get(
                `periodTypeInfo/${subsidiaryDataZustand.selectedPdv.selectedPeriod.periodUuid}`
              ),
            ]);

          const subsidiaryInfo = subsidiaryInfoResponse.data.subsidiaryInfo.map(
            (info: any) => info
          );
          const subsidiaryUpdatedInfo = {
            ...subsidiaryDataZustand,
            ...subsidiaryInfoResponse.data.subsidiary,
            pdvs: subsidiaryInfoResponse.data.pdvs,
            subsidiaryInfo: subsidiaryInfo,
          };

          const periodInfoData =
            periodInfoResponse.data.currentPeriodTypeInfo.periodInfo;
          const periodOrders = periodInfoResponse.data.periodOrders;

          const periodInfo = {
            periodOrders: periodOrders,
            periodDiscounts: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 1)
                .periodTypeInfoValue
            ),
            periodTaxs: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 2)
                .periodTypeInfoValue
            ),
            periodProducts: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 3)
                .periodTypeInfoValue
            ),
            periodPayments: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 4)
                .periodTypeInfoValue
            ),
            periodSequence: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 5)
                .periodTypeInfoValue
            ),
            periodDesks: periodInfoResponse.data.currentPeriodTypeInfo.desks,
            periodCounters:
              periodInfoResponse.data.currentPeriodTypeInfo.counters,
            periodObservations: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 6)
                .periodTypeInfoValue
            ),
            periodDeliveryMans: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 8)
                .periodTypeInfoValue
            ),
            periodCancelReasons: JSON.parse(
              periodInfoData.find((item: any) => item.periodTypeInfoType === 9)
                .periodTypeInfoValue
            ),
            periodBalance: periodInfoResponse.data.availableBalance
              .toFixed(2)
              .replace(".", ","),
          };

          setSubsidiaryDataZustand({
            ...subsidiaryUpdatedInfo,
            selectedPdv: {
              ...subsidiaryUpdatedInfo.selectedPdv,
              selectedPeriod: {
                ...subsidiaryUpdatedInfo.selectedPdv.selectedPeriod,
                periodInfo: periodInfo,
              },
            },
          });
        }
      } catch (error: any) {
        if (error.message === "Network Error") {
          setMessageZustand(
            `Erro ao obter informações do período atual, entre em contato com os administradores do Alfredo da sua unidade.`,
            `error`
          );
        } else {
          setMessageZustand(
            `Erro ao obter informações do período atual: ${error.message}`,
            `error`
          );
        }
      } finally {
        setIsSubmitting(false);
      }
    },
    [isSubmitting, subsidiaryDataZustand, setSubsidiaryDataZustand]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      getPeriodInfo(true);
    }, 5000);
    return () => clearInterval(interval);
  }, [getPeriodInfo]);
  //#endregion

  //#region Usar o useEffect para atualizacao dos campos na tela e executar os atalhos configurados.

  useEffect(() => {
    requestSaleOptionInfo();

    const keydownHandler = (e: KeyboardEvent) => {
      // Manipulação para Enter e Tab
      if ((e.key === "Enter" || e.key === "Tab") && currentModalOpen === "") {
        handleSearch();
        return;
      }
      // Manipulação imediata para Backspace, garantindo fluidez na digitação
      if (currentModalOpen === "" && !saleOptionEditorOpenZustand && e.key === "Backspace" && e.target instanceof HTMLInputElement) {
        e.preventDefault();
        e.target.value = e.target.value.slice(0, -1);
        setSearchValueInput(e.target.value); // Atualiza o estado imediatamente
        return;
      }



      // Manipulação para atalhos e ações quando modais estão fechados
      if (!saleOptionEditorOpenZustand && currentModalOpen === "") {
        const handleOtherKeys = async () => {
          let actionTriggered = false;

          if (selectedSaleOption?.itemInfoValue.saleOptionComponents) {
            for (const component of selectedSaleOption.itemInfoValue.saleOptionComponents) {
              if (e.key === component.componentProps.componentShortcut && e.key !== "Enter") {
                actionTriggered = true;
                e.preventDefault();
                await handleButtonClick(component?.componentProps?.componentAction as string || "");
                break;
              }
            }
          }

          // Outras ações, como Escape e atalhos adicionais
          if (!actionTriggered) {
            if (e.key === "Escape") {
              if (currentModalOpen === "" && (orderDataZustand.orderUuid !== "")) {
                handleEscapeAction();
              }
            } else if (e.ctrlKey && e.key === "h") {
              handleCtrlH();
            } else if (
              e.ctrlKey &&
              Number(e.key) &&
              Number(e.key) <= subsidiaryDataZustand.selectedPdv.saleOptions?.length
            ) {
              handleSaleOptionSelection(Number(e.key));
            } else if (e.key === "ArrowDown") {
              handleArrowDown();
            } else if (e.key === "ArrowUp") {
              handleArrowUp();
            }
          }
        };
        handleOtherKeys();
      }
    };

    const handleEscapeAction = () => {
      if (orderDataZustand?.orderStatus === 0) {
        setCurrentModalOpen("ConfirmationModal");
        setConfirmModalOpen({
          title: "Cancelar a Conta",
          description: "A conta ainda não foi confirmada, deseja cancelar?",
          confirmationAction: async () => {
            try {
              await api.post(`cancelOrder/${orderDataZustand.orderUuid}`);
              handleSetMessage("Conta cancelada com sucesso!", "success");
            } catch (error: any) {
              const errorMessage =
                error.message === "Network Error"
                  ? `Erro ao encerrar a conta, entre em contato com os administradores do Alfredo da sua unidade.`
                  : `Erro ao encerrar a conta: ${error.message}`;
              handleSetMessage(errorMessage, "error");
            }
            resetOrderData();
          },
          cancelationAction: () => { },
        });
      } else {
        resetOrderData();
      }
    };

    const handleCtrlH = () => {
      resetOrderData();
      navigate("/");
    };

    const handleSaleOptionSelection = (index: number) => {
      resetOrderData();
      const saleOption = subsidiaryDataZustand.selectedPdv.saleOptions[index - 1].itemInfoUuid;
      navigate(`/point-of-sale/${saleOption}`);
    };

    const handleArrowDown = () => {
      const selectedProduct = orderDataZustand.products?.find((product: any) => product.productSemiSelected);
      updateProductSelection(selectedProduct, 1);
    };

    const handleArrowUp = () => {
      const selectedProduct = orderDataZustand.products?.find((product: any) => product.productSemiSelected);
      updateProductSelection(selectedProduct, -1);
    };

    const updateProductSelection = (selectedProduct: any, direction: number) => {
      if (selectedProduct && orderDataZustand.products) {
        const index = orderDataZustand.products.indexOf(selectedProduct);
        if (index !== -1 && index + direction >= 0 && index + direction < orderDataZustand.products.length) {
          const newOrderData = { ...orderDataZustand };
          newOrderData?.products?.forEach((product: any, i: number) => {
            product.productSemiSelected = i === index + direction;
          });
          setOrderDataZustand(newOrderData);
        }
      }
    };



    window.addEventListener("keydown", keydownHandler);
    return () => {
      window.removeEventListener("keydown", keydownHandler);
    };
  }, [
    subsidiaryDataZustand,
    setSubsidiaryDataZustand,
    orderDataZustand,
    setOrderDataZustand,
    searchValueInput,
    setSearchValueInput,
    ordersTypeTable,
    setOrdersTypeTable,
    saleOptionEditorOpenZustand,
    currentModalOpen,
    orderDataZustand.orderInfo?.customerName,
  ]);

  //#endregion
  useEffect(() => {
    resetOrderData(); // Limpa os dados sempre que `saleOption` mudar
  }, [saleOption]);
  //#region Retornar o conteudo da tela
  return (
    <Styles.Container
      backgroundColor={
        selectedSaleOption.itemInfoValue.saleOptionBackgroundColor
      }
      width={selectedSaleOption.itemInfoValue.saleOptionWidth}
      height={selectedSaleOption.itemInfoValue.saleOptionHeight}
    >
      <link
        href="https://fonts.googleapis.com/icon?family=Material+Icons"
        rel="stylesheet"
      />
      <AlfredoComponents.MessageBox />
      {authUserZustand?.userInfo.userGroupType === 1 && <SaleOptionEditor />}
      {content}
      <ModaisDoPdv
        currentModalOpen={currentModalOpen}
        setCurrentModalOpen={setCurrentModalOpen}
        confirmationModalOpen={confirmationModalOpen}
        setConfirmModalOpen={setConfirmModalOpen}
        modalPosition={modalPosition}
        searchValueInput={searchValueInput}
        setSearchValueInput={setSearchValueInput}
        searchInputRefType3={searchInputRefType3}
        customerInfoByOrder={customerInfoByOrder}
        setCustomerInfoByOrder={setCustomerInfoByOrder}
        customerAddressToUpdate={customerAddressToUpdate}
        setCustomerAddressToUpdate={setCustomerAddressToUpdate}
        orderDataZustand={orderDataZustand}
        setOrderDataZustand={setOrderDataZustand}
        selectedSaleOption={selectedSaleOption}
        peopleWithProducts={peopleWithProducts}
        availableDesks={availableDesks}
        availableCounters={availableCounters}
        paybackValue={paybackValue}
        handlePayback={handlePayback}
        handleSearch={handleSearch}
        handleSetMessage={handleSetMessage}
        getPeriodInfo={getPeriodInfo}
        setComponent={setComponent}
        resetOrderData={resetOrderData}
      />
    </Styles.Container>
  );
  //#endregion
};

export default PointOfSale;

